import React from 'react'
import { Helmet } from "react-helmet";
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const HelmetSEO = React.memo(({ content }) => {
  const { TITLE = '', DESCRIPTION = '', KEYWORDS = '' } = content
  const { user } = useSelector(state => state?.auth) || { user: {} }
  const { customerData } = user || { customerData: {} }
  const { customer_name } = customerData || { customer_name: "" }

  return (
    <>
      <Helmet>
        <title>{`${TITLE} ${customer_name} `}</title>
        <meta name="description" content={DESCRIPTION} />
        <meta name="keywords" content={`${KEYWORDS} ${customer_name}`} />
        <meta name="author" content="Greytip Software Pvt. Ltd" />
       
      </Helmet>
    </>
  )
})

HelmetSEO.propTypes = {
  content: propTypes.object,
}

HelmetSEO.defaultProps = {
  content: {
    TITLE: "Greytip Pro",
    DESCRIPTION: "",
    KEYWORDS: ""
  }
}

